import { cn } from "@/lib/utils";

interface SquareLoaderProps {
  className?: string;
  label?: string | null;
  size?: "sm" | "md" | "lg";
}

function PeersheepLoader({ className, label = "Loading", size = "md" }: SquareLoaderProps) {
  const dots = Array.from({ length: 25 }, (_, index) => {
    const row = Math.floor(index / 5);
    const column = index % 5;
    const distance = Math.max(Math.abs(row - 2), Math.abs(column - 2));
    const isCenter = distance === 0;
    const ringOrder = distance === 2
      ? row === 0
        ? column
        : column === 4
        ? 4 + row
        : row === 4
        ? 12 - column
        : 16 - row
      : row === 1
      ? column - 1
      : column === 3
      ? 2 + row
      : row === 3
      ? 6 - column
      : 8 - row;

    return { index, distance, isCenter, ringOrder };
  });

  return (
    <div className={cn("flex flex-col items-center gap-3", className)} role="status" aria-label={label ?? "Loading"}>
      <div className={cn("square-loader-grid", `square-loader-${size}`)} aria-hidden="true">
        {dots.map(({ index, distance, isCenter, ringOrder }) => (
          <span
            key={index}
            className={cn(
              "square-loader-dot",
              isCenter && "square-loader-center",
              distance === 1 ? "square-loader-inner" : "square-loader-outer"
            )}
            style={{ animationDelay: `${ringOrder * 70}ms` }}
          />
        ))}
      </div>
      <span className="font-mono text-[10px] font-semibold uppercase tracking-[0.24em] text-foreground">
        PEERSHEEP
      </span>
    </div>
  );
}

const SquareLoader = PeersheepLoader;

export { PeersheepLoader, SquareLoader };